import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  countryWrapper: {
    padding: theme.spacing(1)
  },
  formControl: {
    width: '100%'
  },
  countryImage: {
    marginRight: '10px'
  }
}));

export default useStyles;
